import React from 'react'
import { Grid } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { DataSegment as DataSegmentBase } from 'shared/Helpers'
import { GridContainer } from 'shared/StyledComponents'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import { reactForm, FormField } from 'shared/reactForm'
import { addNote, closeRevolving } from '../../store/loan'
import { withConstantPermissions, withLivedata, colors, withUserConfig } from 'shared'
import withLookups, { LookupType } from 'shared/containers/withLookups'
import { connect } from 'react-redux'
import mainTranslate from 'loankeeper-common/helpers/language'
import { CLOSE_CHECK_MODAL } from './constants'

const Hr = () => <hr style={{ marginTop: 10, marginBottom: 10 }} />

const DataSegment = ({ className, style, children, center }) => (
  <DataSegmentBase
    className={`u-fluid ${(center && 'u-textCenter ') || ''}${className || ''}`}
    style={{ ...style, backgroundColor: 'whitesmoke', height: 33 }}
  >
    {children}
  </DataSegmentBase>
)

const translate = (key) => mainTranslate(`frm_loan_close_check-${key}`)
const translateLKM = (name) => mainTranslate(`LKMESSAGE-${name}`)

const ERR_REQUIRED_FIELD = translateLKM('ERR_REQUIRED_FIELD')

@LKModalContainer(CLOSE_CHECK_MODAL)
@withConstantPermissions(['REVOLVING_FORCE_CLOSE as RevolvingForceClose'])
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDayStr', 'CCYOfficalRates'])
@withLookups({ query: ['Nodes'] })
@withUserConfig(['NodeID', 'CashAccounts'])
@withLookups({ type: LookupType.Users, query: '* as users' })
@connect(undefined, {
  openError: (message) => LKModalActions.openError(message),
  openInfo: (message) => LKModalActions.openInfo(message),
  addNote,
})
@connect(undefined, (dispatch) => ({
  closeRevolving: (params) => dispatch(closeRevolving(params)),
}))
@reactForm({
  initialValues: (props) => ({
    CloseLine: true,
    AddNote: false,
    NodeID: props.NodeID,
    GDate: props.OpenDayStr,
    Comment: '',
  }),
  validate: (values, props) => ({
    GDate: !values.GDate || LKDate.from(values.GDate) < LKDate.from(props.OpenDayStr) ? ERR_REQUIRED_FIELD : undefined,
  }),
})
class LoanCloseCheck extends React.Component {
  constructor(props) {
    super(props)

    this.Nodes = props.Nodes.map((n) => ({ value: n.ID, text: n.Title }))
  }

  submit = async (values) =>
    (values.AddNote
      ? this.props.addNote({
          LoanID: this.props.params.ID,
          HashSum_LoanID_: this.props.params.hash,
          StateID: 1,
          PriorityID: 1,
          TypeID: 2,
          NodeID: values.NodeID,
          GDate: values.GDate,
          Comment: values.Comment,
        })
      : Promise.resolve()
    )
      .then(() => {
        if (values.CloseLine) {
          // return Loan.closeRevolving(this.props.params.ID, this.props.params.hash)

          //UPDATED API REQUEST loan_oper_api page: closerevolving
          return this.props
            .closeRevolving({
              LoanID: this.props.params.ID,
              HashSum_LoanID_: this.props.params.hash,
            })
            .then((response) => {
              if (!closeRevolving.fulfilled.match(response)) {
                throw { Error: { Message: response.payload } }
              }
            })
        }
        Promise.resolve()
      })
      .then(() => {
        if (this.props.onSuccess) {
          this.props.onSuccess()
        }
        this.props.closeModal()
      })
      .catch((e) => {
        this.props.openError(e.Error ? e.Error.Message || e.Error.Text : translateLKM('HINT_ERR_TITLE'))
      })

  handleSubmit = () => {
    this.props.form.handleSubmit(this.submit)
  }

  render() {
    const { modalInstanceName, form } = this.props

    const { submitting, values } = form

    let title = `${translate('frm_loan_close_check')}`

    if (this.loan)
      title += ` - ${this.loan.FullName} - ${this.loan.ISO} - ${this.loan.AgreementNo} / ${this.loan.ManagerName}`

    return (
      <>
        <LKModal
          icon="cover"
          name={modalInstanceName}
          heading={title}
          size="medium"
          footer={
            <LKModal.Footer>
              <LKBaseButton.Okay
                disabled={submitting}
                loading={submitting}
                onClick={this.handleSubmit}
                style={{ marginLeft: '0.25em' }}
              />
            </LKModal.Footer>
          }
        >
          <div style={{ height: values.AddNote ? 400 : 150 }}>
            <div
              className="u-flex u-directionRow u-flexCenter u-padding-10 u-marginBottom-10"
              style={{ borderBottom: '1px solid lightgray', backgroundColor: colors.yellow }}
            >
              {translate('pan_0')}
            </div>

            {this.props.params.RevolvingID === 2 && (
              <>
                <div className="u-flex u-directionRow u-flexCenter">
                  <FormField
                    type="checkbox"
                    form={form}
                    name="CloseLine"
                    disabled={!this.props.RevolvingForceClose}
                    label={translate('pan_revolving_close')}
                  />
                </div>

                <Hr />
              </>
            )}

            <div className="u-flex u-directionRow u-flexCenter">
              <FormField type="checkbox" form={form} name="AddNote" label={translate('pan_gold_date')} />
            </div>

            <Hr />

            {values.AddNote && (
              <GridContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight">
                      {translate('lbl_node')}
                    </Grid.Column>

                    <Grid.Column width={10} className="u-flex u-directionRow u-flexCenter">
                      <FormField type="select" form={form} name="NodeID" options={this.Nodes} />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight">
                      {translate('lbl_date')}
                    </Grid.Column>

                    <Grid.Column width={2} className="u-flex u-directionRow u-flexCenter">
                      <FormField type="date" form={form} name="GDate" />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight">
                      {translate('lbl_current_location_t')}
                    </Grid.Column>

                    <Grid.Column width={10} className="u-flex u-directionRow u-flexCenter">
                      <DataSegment>{this.props.params.Location}</DataSegment>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={16} className="u-flex u-directionRow u-alignCenter u-pullRight">
                      <FormField
                        type="textarea"
                        form={form}
                        name="Comment"
                        height={this.props.params.RevolvingID === 2 ? 140 : 177}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            )}
          </div>
        </LKModal>
      </>
    )
  }
}

export default LoanCloseCheck
